import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../../translation/translation';

function AllMissing({ highlight }) {
    const containerClassName = ['statusbar-mobile-current-status__size-cta'];

    if (highlight) {
        containerClassName.push('statusbar-mobile-current-status__size-cta--highlight-' + highlight);
    }

    return (
        <Translation
            translationKey="catalog-statusbar-mobile-add-tyre-size"
            className={containerClassName.join(' ')}
        />
    );
}

AllMissing.propTypes = {
    highlight: PropTypes.string
};

AllMissing.defaultProps = {
    highlight: ''
};

export { AllMissing };
